import { variantBPressLogos } from "../../../Utils/variantBAssets";

export function AsFeaturedOn() {
  return (
    <section className="lv2-as-featured-on" aria-label="As featured on">
      <h2>As featured on</h2>
      <div className="lv2-as-featured-on__logos">
        {variantBPressLogos.map(([name, src]) => (
          <img key={name} src={src} alt={name} />
        ))}
      </div>
    </section>
  );
}
